export default {
    'NEW_CHANGES': 'draft',
    'SAVED_AS_DRAFT': 'saved-as-draft',
    'PUBLISHED': 'published',
}